import { useTranslation } from 'react-i18next'

import { IntradayBulkResultBanner } from '~/pages/IntradayBidding/components/IntradayBulkResultBanner'
import { IntradayFailedBidsTable } from '~/pages/IntradayBidding/components/IntradayFailedBidsTable'
import type { IntradayBulkDeleteRefused } from '~/pages/IntradayBidding/hooks/useIntradayBulkDelete'
import { intradayBulkDeleteRefusalCounts } from '~/pages/IntradayBidding/models/intradayBulkDelete'

const KEY = 'page:biddingIntraday.bulkDelete.refused'

type Props = {
  refused: IntradayBulkDeleteRefused
  onDismiss: () => void
}

/**
 * 入札を全削除で削除しなかった札があった時のエラーバナー (AC-BIN-138)。 見出しは削除できた件数
 * (0 件なら見出しを出さず本文だけ)、 本文は照合で外した件数 {M} とそれ以外の件数 {K}。 札ごとの
 * 理由は「詳細を見る」 のダイアログに並べる。 バナーの形は `IntradayBulkResultBanner`。
 */
export const IntradayBulkDeleteRefusedBanner = ({
  refused,
  onDismiss,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const counts = intradayBulkDeleteRefusalCounts(refused.bids)
  return (
    <IntradayBulkResultBanner
      detailsSize="xl"
      detailsTitle={t(`${KEY}.detailsTitle`)}
      lines={[
        ...(counts.updatedByOther > 0
          ? [
              t(`${KEY}.count.updatedByOther`, {
                count: counts.updatedByOther,
              }),
            ]
          : []),
        ...(counts.other > 0
          ? [t(`${KEY}.count.other`, { count: counts.other })]
          : []),
      ]}
      onDismiss={onDismiss}
      title={
        refused.deletedCount > 0
          ? t(`${KEY}.title`, { count: refused.deletedCount })
          : undefined
      }
    >
      <IntradayFailedBidsTable
        rows={refused.bids.map(({ bid, reason }) => ({
          bid,
          reason: t(`${KEY}.reason.${reason}`),
        }))}
      />
    </IntradayBulkResultBanner>
  )
}
